import { BaseWorkflowRuleCollection } from '@/modules/workflow/models/BaseWorkflowRuleCollection';
import { WorkflowEstateRule } from '/@/modules/workflow/models/WorkflowEstateRule';
import { EstateType } from '@/modules/estate/enums/EstateType';
import Lang from '@/modules/core/app/services/Lang';
import { WorkflowRuleType } from '/@/modules/workflow/enums/WorkflowRuleType';

export class WorkflowEstateRuleCollection extends BaseWorkflowRuleCollection<WorkflowEstateRule> {
  constructor(items: WorkflowEstateRule[] | WorkflowEstateRuleCollection | undefined) {
    super(items, WorkflowEstateRule);
  }

  static mapModel(
    items: WorkflowEstateRule[] | WorkflowEstateRuleCollection | undefined
  ): WorkflowEstateRuleCollection {
    return new this(items);
  }

  get estateTypes(): EstateType[] {
    return (
      this.items?.map(
        (estateRule: WorkflowEstateRule): EstateType =>
          EstateType.getByKey(estateRule.estateType) as EstateType
      ) ?? []
    );
  }

  sync(estateTypeSelection: EstateType[]): void {
    super.syncRules(
      estateTypeSelection.map(
        (estateType: EstateType): WorkflowEstateRule =>
          WorkflowEstateRule.mapModel({
            estateType: estateType.key
          })
      )
    );
  }

  get ruleText(): string {
    return this.count > 1 ? Lang.t('workflow.product-in') : Lang.t('workflow.product-is');
  }

  get ruleType(): string {
    return WorkflowRuleType.PRODUCT.key;
  }

  get ruleSelection(): EstateType[] {
    return this.estateTypes;
  }
}
